/** Version courante des CGU affichées dans l’ERP. */
export const CGU_VERSION = '1.0';

export const CGU_TITLE = 'NEXXUS ERP — Conditions Générales d’Utilisation';

/** Période de publication de la version courante des CGU. */
export const CGU_PERIOD = 'Octobre 2026';

const SCROLL_UNLOCK_RATIO = 0.95;

/** Compare deux versions type « 1.0 » / « 1.1 ». */
export function compareCguVersions(a: string, b: string): number {
  const pa = a.split('.').map((n) => Number.parseInt(n, 10) || 0);
  const pb = b.split('.').map((n) => Number.parseInt(n, 10) || 0);
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i += 1) {
    const da = pa[i] ?? 0;
    const db = pb[i] ?? 0;
    if (da !== db) return da < db ? -1 : 1;
  }
  return 0;
}

export function isCguVersionCurrent(acceptedVersion: string, current = CGU_VERSION): boolean {
  return compareCguVersions(acceptedVersion, current) === 0;
}

export function isCguVersionOutdated(acceptedVersion: string, current = CGU_VERSION): boolean {
  return compareCguVersions(acceptedVersion, current) < 0;
}

/** True si le défilement a atteint le seuil d’activation du bouton Accepter. */
export function hasReadCguEnough(scrollRatio: number): boolean {
  return scrollRatio >= SCROLL_UNLOCK_RATIO;
}

export function cguScrollRatio(
  scrollTop: number,
  scrollHeight: number,
  clientHeight: number,
): number {
  const max = scrollHeight - clientHeight;
  if (max <= 0) return 1;
  return Math.min(1, Math.max(0, scrollTop / max));
}
